import React from "react";

import { IViewProps, View } from "core/decorators/View";
import EmbedViewConfig from "./EmbedViewConfig";

interface IEmbedViewProps extends IViewProps<EmbedViewConfig> {
	src: string;
}

@View({
	id: "embed",
	configClass: EmbedViewConfig
})
export default class EmbedView extends React.PureComponent<IEmbedViewProps> {

	public render() {
		const { config, src } = this.props;

		if (!src || !src.startsWith('https:')) {
			return null;
		}

		return (
			<iframe
				src={src}
				style={{
					border: config.border,
					height: config.height,
					width: config.width || "100%"
				}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/embed/Embed.view.tsx